import React from 'react';
import { aliases } from '../../i18n/i18n';
import { Button, Modal, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from '../../nacre/components/LanguageSelector';
import Style from './widgetRow.module.css';
import { fetcher } from '@weezevent/weezjs-core';

const MylanguageSelector = ({ widget, showLanguage, displayLanguage, organizationId }) => {
    const { t } = useTranslation();
    let lang = aliases[widget.default_language] || widget.default_language;
    const [widgetLang, setWidgetLang] = React.useState(lang);
    const toast = React.useContext(ToastContext);

    const changeDefaultLanguage = React.useCallback(() => {
        const data = {
            default_language: widgetLang
        };
        widget.event
            ? fetcher
                  .patch(`/ticket/organizations/${organizationId}/widget_events/${widget.id}`, { data })
                  .then(() => {
                      toast.success(t('ticket.widgets.language_selector.sucess'));
                  })
                  .catch(e => {
                      toast.error(`${e.name} StatusCode: ${e.code}`);
                  })
                  .finally(() => displayLanguage(false))
            : fetcher
                  .patch(`/ticket/organizations/${organizationId}/widgets/${widget.id}`, { data })
                  .then(() => {
                      toast.success(t('ticket.widgets.language_selector.sucess'));
                  })
                  .catch(e => {
                      toast.error(`${e.name} StatusCode: ${e.code}`);
                  })
                  .finally(() => displayLanguage(false));
    }, [widgetLang]);
    return (
        <>
            {showLanguage && (
                <Modal
                    size="medium"
                    open={showLanguage}
                    title={t('ticket.widgets.language_selector.title')}
                    subtitle={t('ticket.widgets.language_selector.subtitle')}
                    onClose={() => displayLanguage(false)}
                    submitButton={<Button primary onClick={changeDefaultLanguage} label={t('ticket.common.action.save')} />}
                    cancelButton={<Button onClick={() => displayLanguage(false)} label={t('ticket.common.action.back')} />}
                >
                    <div>
                        {t('ticket.widget.list.languageIntegration')}
                        <div className={Style['language_selector']}>
                            <LanguageSelector
                                lang={widgetLang}
                                onChange={(_, { value }) => {
                                    setWidgetLang(value);
                                }}
                                arrayLangDefault={widget.languages}
                            />
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default MylanguageSelector;
